import { render, staticRenderFns } from "./IbButtonGenerating.vue?vue&type=template&id=5edaf272&scoped=true"
import script from "./IbButtonGenerating.vue?vue&type=script&lang=js"
export * from "./IbButtonGenerating.vue?vue&type=script&lang=js"
import style0 from "./IbButtonGenerating.vue?vue&type=style&index=0&id=5edaf272&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edaf272",
  null
  
)

export default component.exports